// @ts-ignore
/* eslint-disable */
import request from '../../utils/request';

/** 创建推广事件 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 POST /ad-event/trace/upload */
export async function adEventTraceUploadUsingPOST(
  body: API.AdEventTraceUploadReq,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultVoid>('/ad-event/trace/upload', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}
